import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-strip" />
      <div className="site-footer-inner">
        <div className="footer-columns">
          <div className="footer-column">
            <h2 className="footer-title">Pub Quiz</h2>
            <p className="subheader">Friday 9th October 7:30pm</p>
            <address className="footer-address">
              The Stroud Hotel
              <br />
              Station Road
              <br />
              Stroud
              <br />
              GL5 3AP
            </address>
          </div>

          <div className="footer-column">
            <h2 className="footer-title">Ceremony & Reception</h2>
            <p className="subheader">Saturday 10th October - from noon</p>
            <address className="footer-address">
              Copsegrove Farm
              <br />
              Back Lane
              <br />
              Bisley
              <br />
              Stroud
              <br />
              GL6 7BG
            </address>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
